<template>
  <NotificationTemplatesForm :account-id="accountId" />
</template>

<script>
import NotificationTemplatesForm from '@/components/Application/Manage/Account/NotificationTemplatesForm'

export default {
  components: {
    NotificationTemplatesForm
  },
  data () {
    return {
      accountId: this.$route.params.accountId,
      breadcrumb: {
        name: 'Notification Templates',
        route: { name: 'manage-accounts-account-configurations-notificationtemplates', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
